/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Nav,
  Navbar,
  NavItem,
  Dropdown,
  MenuItem,
} from 'react-bootstrap';

import MediaQuery from 'react-responsive';
import * as media from '../../constants/mediaQueries';
import './style.sass';

import { MenuIcon } from '../SharedComponents/Icons';

import OrderFormTrigger from './OrderFormTrigger';
import OrderFormMobileWrapper from './OrderFormMobileWrapper';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cookiesAreAccepted: localStorage.getItem('cookiesAccepted'),
    };

    this.acceptCookie = this.acceptCookie.bind(this);
  }

  acceptCookie = () => {
    localStorage.setItem('cookiesAccepted', true);

    this.setState({
      cookiesAreAccepted: true,
    });
  };

  render() {
    const {
      about,
      kontor,
      meeting_room,
      signup,
      virtual,
    } = this.props.urls;

    const { logoPath, privacyPage, siteName } = this.props;

    const { cookiesAreAccepted } = this.state;

    const siteNameUpperCase = siteName.charAt(0).toUpperCase() + siteName.slice(1);

    return (
      <div
        className={`header ${cookiesAreAccepted
          ? 'header__cookies-accepted'
          : 'header__cookies-unaccepted'} ${privacyPage
          ? 'header__privacy-page-link'
          : ''}`}
        id="js-header"
      >
        {/*{!cookiesAreAccepted && (*/}
        {/*  <div className="header__cookie-wrapper">*/}
        {/*    <div className="container">*/}
        {/*      <div className={`header__cookie-container ${privacyPage ? 'header__cookie-privacy-page' : ''}`}>*/}
        {/*        <div className="header__cookie-text">*/}
        {/*          {I18n.t('generic.cookies_text', { site: siteNameUpperCase })}*/}
        {/*          {privacyPage && (*/}
        {/*            <a href={`/${privacyPage}`} title={I18n.t('generic.read_more')}>*/}
        {/*              {I18n.t('generic.read_more')}*/}
        {/*            </a>*/}
        {/*          )}*/}
        {/*        </div>*/}
        {/*        <div*/}
        {/*          className="header__cookie-button"*/}
        {/*          onKeyPress={() => {}}*/}
        {/*          role="button"*/}
        {/*          tabIndex="0"*/}
        {/*          onClick={this.acceptCookie}*/}
        {/*        >*/}
        {/*          {I18n.t('generic.okay')}*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*)}*/}
        {(cookiesAreAccepted && privacyPage) && (
          <div className="header__cookie-wrapper--white">
            <div className="container">
              <div className={`header__cookie-container ${privacyPage ? 'header__cookie-privacy-page' : ''}`}>
                <div className="header__cookie-text">
                  {privacyPage && (
                    <a href={`/${privacyPage}`} title={I18n.t('generic.privacy_policy')}>
                      {I18n.t('generic.privacy_policy')}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="header__container">
          <MediaQuery minWidth={media.SCREEN_MD}>
            <Navbar>
              <Navbar.Header>
                <Navbar.Brand>
                  <a href="/" target="_top">
                    <img className="logoImage" src={logoPath} alt="main logo" />
                  </a>
                </Navbar.Brand>
              </Navbar.Header>
              <Nav pullRight>
                <NavItem
                  className={window.location.pathname === kontor ? 'active-link' : ''}
                  href={kontor}
                  title={I18n.t('generic.office_search')}
                >
                  {I18n.t('generic.office_search')}
                </NavItem>
                <NavItem
                  className={window.location.pathname === meeting_room ? 'active-link' : ''}
                  href={meeting_room}
                  title={I18n.t('generic.kinds.meeting_room', { count: 1 })}
                >
                  {I18n.t('generic.kinds.meeting_room', { count: 1 })}
                </NavItem>
                <NavItem
                  className={window.location.pathname === virtual ? 'active-link' : ''}
                  href={virtual}
                  title={I18n.t('generic.kinds.virtual_office', { count: 1 })}
                >
                  {I18n.t('generic.kinds.virtual_office', { count: 1 })}
                </NavItem>
                <NavItem
                  className={window.location.pathname === signup ? 'active-link' : ''}
                  href={signup}
                  title={I18n.t('generic.become_a_landlord')}
                >
                  {I18n.t('generic.become_a_landlord')}
                </NavItem>
                <NavItem
                  className={window.location.pathname === about ? 'active-link' : ''}
                  href={about}
                  title={I18n.t('generic.about')}
                >
                  {I18n.t('generic.about')}
                </NavItem>
              </Nav>
            </Navbar>
          </MediaQuery>

          <MediaQuery maxWidth={media.SCREEN_SM_MAX}>
            <div className="header__logo">
              <a href="/" target="_top">
                <img className="logoImage" src={logoPath} alt="main logo" />
              </a>
            </div>
            <div className="order-form--mobile">
              <Dropdown id="order-form-mobile">
                <OrderFormTrigger bsRole="toggle" selectedLocations={this.props.selectedLocations} />
                <OrderFormMobileWrapper
                  bsRole="menu"
                  removeLocationFromOrder={this.props.removeLocationFromOrder}
                  selectedLocations={this.props.selectedLocations}
                />
              </Dropdown>
            </div>
            <Dropdown id="mobile-header">
              <Dropdown.Toggle noCaret>
                <MenuIcon />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <MenuItem href={kontor} className={window.location.pathname === kontor ? 'active-link' : ''} eventKey="1">{I18n.t('generic.office_search')}</MenuItem>
                <MenuItem href={meeting_room} className={window.location.pathname === meeting_room ? 'active-link' : ''} eventKey="2">{I18n.t('generic.kinds.meeting_room', { count: 1 })}</MenuItem>
                <MenuItem href={virtual} className={window.location.pathname === virtual ? 'active-link' : ''} eventKey="3">{I18n.t('generic.kinds.virtual_office', { count: 1 })}</MenuItem>
                <MenuItem href={signup} className={window.location.pathname === signup ? 'active-link' : ''} eventKey="4">{I18n.t('generic.become_a_landlord')}</MenuItem>
                <MenuItem href={about} className={window.location.pathname === about ? 'active-link' : ''} eventKey="5">{I18n.t('generic.about')}</MenuItem>
                {(cookiesAreAccepted && privacyPage) && (
                  <MenuItem href={`/${privacyPage}`} eventKey="6">{I18n.t('generic.privacy_policy')}</MenuItem>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </MediaQuery>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  urls: PropTypes.oneOfType([PropTypes.object]),
  removeLocationFromOrder: PropTypes.func,
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
  logoPath: PropTypes.string,
  privacyPage: PropTypes.string,
  siteName: PropTypes.string,
};

Header.defaultProps = {
  urls: {},
  removeLocationFromOrder: () => true,
  selectedLocations: [],
  logoPath: '',
  privacyPage: '',
  siteName: '',
};

export default Header;
